import React, { useState } from "react";
import {
  Card,
  CardContent,
  TextField,
  Button,
  Typography,
  Box,
  Stack,
  Alert,
} from "@mui/material";
import { useNavigate } from "react-router-dom";
import api from "../api";

export default function RegisterPage() {
  const [formData, setFormData] = useState({
    username: "",
    password: "",
    full_name: "",
  });
  const [status, setStatus] = useState({ type: "", msg: "" });
  const navigate = useNavigate();

  const handleRegister = async () => {
    try {
      const res = await api.post("/register", formData);
      if (res.data.success) {
        setStatus({
          type: "success",
          msg: "Admin oluşturuldu! Giriş sayfasına yönlendiriliyorsunuz...",
        });
        setTimeout(() => navigate("/"), 2000);
      }
    } catch (err) {
      setStatus({ type: "error", msg: "Hata oluştu." });
    }
  };

  return (
    <Box
      sx={{
        minHeight: "80vh",
        display: "flex",
        alignItems: "center",
        justifyContent: "center",
      }}
    >
      <Card sx={{ maxWidth: 400, width: "100%", borderRadius: 4 }}>
        <CardContent sx={{ p: 4 }}>
          <Typography variant="h5" fontWeight="800" mb={3} textAlign="center">
            Sistem İlk Kurulum (Admin)
          </Typography>
          {status.msg && (
            <Alert severity={status.type} sx={{ mb: 2 }}>
              {status.msg}
            </Alert>
          )}
          <Stack spacing={2}>
            <TextField
              label="Ad Soyad"
              fullWidth
              onChange={(e) =>
                setFormData({ ...formData, full_name: e.target.value })
              }
            />
            <TextField
              label="Kullanıcı Adı"
              fullWidth
              onChange={(e) =>
                setFormData({ ...formData, username: e.target.value })
              }
            />
            <TextField
              label="Şifre"
              type="password"
              fullWidth
              onChange={(e) =>
                setFormData({ ...formData, password: e.target.value })
              }
            />
            <Button
              variant="contained"
              fullWidth
              onClick={handleRegister}
              sx={{ py: 1.5, fontWeight: "bold" }}
            >
              Admin Olarak Kaydol
            </Button>
          </Stack>
        </CardContent>
      </Card>
    </Box>
  );
}
